module.exports = __webpack_public_path__ + "static/media/logout.b77160a0.png";